/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MemberResponseDto } from './memberResponseDto';
import { DonationResponseDto } from './donationResponseDto';
import { NoteResponseDto } from './noteResponseDto';


export interface FamilyResponseDto { 
    id?: number | null;
    createdOn?: string | null;
    updatedOn?: string | null;
    deletedOn?: string | null;
    readonly isDeleted?: boolean;
    readonly isNewRecord?: boolean;
    representative?: string | null;
    phone?: string | null;
    address?: string | null;
    city?: string | null;
    documents?: boolean;
    residence?: string | null;
    lastDonation?: DonationResponseDto;
    members?: Array<MemberResponseDto> | null;
    donations?: Array<DonationResponseDto> | null;
    notes?: Array<NoteResponseDto> | null;
}

